import React from 'react'
import { keyTest } from 'shared/utils'
import { Box } from '@mui/material'
import {
  useAllFrameworks,
  useFrameworkForId,
} from 'domains/scope-and-sequence/hooks'
import { ItemSelect } from './ItemSelect'

export function FrameworkIdDisplay<T extends { id: number }>({
  item,
  columnData: { key: frameworkIdKey },
}: {
  item: T
  columnData: { key: string }
}) {
  const frameworkId = keyTest(item, frameworkIdKey)
    ? item[frameworkIdKey]
    : undefined
  const framework = useFrameworkForId(Number(frameworkId))
  if (!frameworkId) return <Box />
  if (!framework) return <Box>{`${frameworkId} NOT FOUND`}</Box>
  return <Box>{framework?.name}</Box>
}

export function FrameworkIdEdit<T extends { id: number }>({
  item,
  columnData: { key: frameworkIdKey, setKey },
}: {
  item: T
  columnData: { key: string; setKey?: string }
}) {
  const hasKey = keyTest(item, frameworkIdKey)
  const frameworkId = hasKey ? Number(item[frameworkIdKey]) : undefined

  return (
    <FrameworkSelect
      initialItemId={frameworkId}
      setKey={setKey ?? frameworkIdKey}
    />
  )
}

function FrameworkSelect({
  initialItemId,
  setKey,
}: {
  initialItemId?: number
  setKey: string
}) {
  const frameworks = useAllFrameworks()
  const initialItem = useFrameworkForId(initialItemId)

  if (!frameworks?.length) return null

  return (
    <ItemSelect
      setKey={setKey}
      items={frameworks}
      initialItem={initialItem}
      itemDisplay={(framework) => framework?.name ?? ''}
    />
  )
}
